import type { SVGProps } from "react";

export default function StarsIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.694 3.0482C6.98228 2.31727 8.01674 2.31727 8.30502 3.04821L9.19834 5.31332C9.28634 5.53648 9.46301 5.71313 9.68618 5.80114L11.9513 6.69449C12.6823 6.98277 12.6823 8.01723 11.9513 8.30551L9.68618 9.19883C9.46301 9.28683 9.28634 9.4635 9.19834 9.68667L8.30502 11.9518C8.01674 12.6827 6.98228 12.6827 6.694 11.9518L5.80065 9.68667C5.71264 9.4635 5.53599 9.28683 5.31284 9.19883L3.04771 8.30551C2.31678 8.01722 2.31678 6.98277 3.04772 6.69449L5.31284 5.80114C5.53599 5.71312 5.71264 5.53648 5.80065 5.31332L6.694 3.0482Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M13.7401 11.124C13.8926 10.7373 14.4401 10.7373 14.5926 11.124L15.2597 12.8157C15.3063 12.9338 15.3998 13.0273 15.5179 13.0739L17.2096 13.741C17.5963 13.8935 17.5963 14.441 17.2096 14.5935L15.5179 15.2607C15.3998 15.3073 15.3063 15.4008 15.2597 15.5189L14.5926 17.2105C14.4401 17.5973 13.8926 17.5973 13.7401 17.2105L13.0729 15.5189C13.0263 15.4008 12.9328 15.3073 12.8147 15.2607L11.1231 14.5935C10.7363 14.441 10.7363 13.8935 11.1231 13.741L12.8147 13.0739C12.9328 13.0273 13.0263 12.9338 13.0729 12.8157L13.7401 11.124Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
